import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import AccessDenied from '../pages/AccessDenied/AccessDenied'
import SiteMaintenance from '../pages/SiteMaintenance/SiteMaintenance'

const AuthRoute = ({ children, ...props }: any) => {
  const {
    path,
    component: Component,
    isAuthorized: isAuth,
    serviceError: error,
    arb,
    ...rest
  } = props
  const authResponse = JSON.parse(localStorage.getItem('_Gresponse') || '{}')
  const idToken = authResponse?.credential

  if (idToken && isAuth) {
    return Component ? (
      <Route component={Component} path={path} {...rest} />
    ) : (
      <Route render={() => children} path={path} {...rest} />
    )
  } else if (idToken && error && !arb) {
    return <Route component={SiteMaintenance} path={path} {...rest} />
  } else if (idToken && !isAuth && !arb) {
    return <Route component={AccessDenied} path={path} {...rest} />
  } else if (arb) {
    return <Route component={Component} path={path} {...rest} />
  } else {
    return <Redirect to="/login" />
  }
}

export default AuthRoute
